import React from 'react';
// TODO this entire function could probably be cleaned up and improved using recursive functions.
/** Parses the &#8480; and &trade; and adds them as JSX.Element */
export const addSuperscript = (text) => {
    // Split the string wherever &#8480; appears.
    const smSplit = text.split('&#8480;');
    // Take every string in `smSplit` and split it wherever &trade; appears.
    const smtmSplit = (() => {
        return smSplit.map(x => x.split('&trade;'));
    })();
    // Convert smtmSplit into JSX.Elements, re-adding (ie appending) &#8480; and &trade; as elements where the strings were split.
    return (React.createElement(React.Fragment, null, smtmSplit.map((x, xIndex) => {
        const mappedItem = x.map((y, yIndex) => (React.createElement(React.Fragment, null,
            y,
            yIndex !== x.length - 1 && React.createElement(React.Fragment, null, "\u2122"))));
        return (React.createElement(React.Fragment, null,
            mappedItem,
            xIndex !== smtmSplit.length - 1 && React.createElement(React.Fragment, null, "\u2120")));
    })));
};
//# sourceMappingURL=addSuperscript.js.map